'use client';

import { useSyncExternalStore } from 'react';

let unreadSnapshot = 0;
const listeners = new Set<() => void>();

export function publishStemUnreadCount(value: number) {
  const next = Math.max(0, Math.floor(Number(value) || 0));
  if (next === unreadSnapshot) return;
  unreadSnapshot = next;
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useStemUnreadCount() {
  return useSyncExternalStore(subscribe, () => unreadSnapshot, () => 0);
}
